import React from 'react';
import { Container, Section } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { AppI18n } from '../../i18n';
import { SECTION_IDS } from '../../../consts';
import { useBI, useImpression, SECTION_NAMES } from '../../bi';
import { CITIES, PHOTOS } from './constants';
import { sectionWrap, heading, citiesWrap, cityName, photoCards } from './styles.ve.css';

export const OfficesSection = () => {
    const bi = useBI();
    const impressionRef = useImpression<HTMLDivElement>(() =>
        bi.reportSectionImpression({ sectionName: SECTION_NAMES.offices })
    );

    return (
        <Section fullWidth backgroundColor="white">
            <Container
                ref={impressionRef}
                id={SECTION_IDS.offices}
                className={sectionWrap}
                position="relative"
                overflow="hidden"
            >
                {/* Photo cards rendered first — they are behind heading and cities in DOM order */}
                {PHOTOS.map((photo, i) => (
                    <Container key={i} className={photoCards[i]} position="absolute" overflow="hidden">
                        <Image
                            src={photo}
                            alt=""
                            objectFit="cover"
                            position="absolute"
                            top={0}
                            left={0}
                            width="100%"
                            height="100%"
                        />
                    </Container>
                ))}

                <Typography as="h2" className={heading}>
                    <AppI18n k="offices.heading" />
                </Typography>

                <Container className={citiesWrap} position="absolute">
                    {CITIES.map((city) => (
                        <Typography
                            key={city.key}
                            as="span"
                            fontWeight="semibold"
                            whiteSpace="nowrap"
                            color="black"
                            className={cityName}
                        >
                            <AppI18n k={`offices.cities.${city.key}`} />
                        </Typography>
                    ))}
                </Container>
            </Container>
        </Section>
    );
};
